export default __webpack_public_path__ + "static/media/Inspect-it.8fb2fbca.apk";